import React from 'react';
import TrainersNavbar from './TrainerNavbar';
import ThreeDAnimation from '../components/ThreeDAnimation';
import '../styles/TrainerDashboard.css'; // Import CSS file for TrainerDashboard

const TrainerDashboard = ({ onLogout }) => {
  return (
    <div>
      <TrainersNavbar />
      <div className="dashboard-container">
        <div className="quote-container">
        </div>
        <h1>Trainer Dashboard</h1>
        <ThreeDAnimation />
        <p className="animated-quote">"The best way to predict the future is to create it." - Peter Drucker</p>

        <div className="dashboard-content">
          <div className="card">
            <h2>Students</h2>
            <p>Manage your students and their progress.</p>
          </div>
          <div className="card">
            <h2>Timetable</h2>
            <p>View and manage your timetable.</p>
          </div>
          <div className="card">
            <h2>Messages</h2>
            <p>Send and receive messages.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerDashboard;
